// moz667: por culpa de vrdemo
var $ = jQuery;

var $wrap = $("#streaming-questions-manage");
var is_on_execution = false;
var next_init_timeout = null;

// FIXME: hacer que el dialogo de alerta no ponga el backdrop? o alguna otra forma que no moleste tanto

function next_init() {
    is_on_execution = false;

    // Cada 5 segundos
    next_init_timeout = setTimeout(init, 5000);
}

function init() {
    if (!is_on_execution) {
        is_on_execution = true;
    } else {
        return;
    }

    $.ajax({
        method: "GET",
        url: $wrap.data("url-get")
    }).fail(function() {
        console.log("ERROR al recibir las preguntas!!");
    }).done(function(data) {
        $wrap.find(".badge").html(data["total"]);
        var $tbody = $wrap.find("tbody");
        $tbody.html("");

        if (data["total"] > 0) {
            for (var i = 0; i < data["questions"].length; i++) {
                var q = data["questions"][i];
    
                var $tr = $('<tr />');
                $tr.append($('<th scope="row" />').text(i + 1));
                $tr.append($('<td class="col-time" />').text(q.time));
                $tr.append($('<td class="col-question" />').text(q.question));
                $tr.append($('<td class="col-autor" />').text(q.author));
                $tr.append($('<td class="col-email" />').text(q.email));
                $tr.append($('<td class="col-delete" />').append(
                    $('<button class="btn btn-danger" data-id="' + q.id + '"><i class="fa fa-close"></i></button>')
                ));
                $tbody.append($tr);
            }

            $tbody.find(".btn-danger").on("click", function () {
                // FIXME: No se me ocurre una opcion mas elegante para evitar que se machaquen entre el click y el loop
                // mas que esperar a que termine de ejecutarse...
                while (is_on_execution) { }
                is_on_execution = true;
                clearTimeout(next_init_timeout);

                var $cur_btn = $(this);

                $.ajax({
                    method: "GET",
                    url: $wrap.data("url-hide"),
                    data: {
                        id: $cur_btn.data("id")
                    }
                }).fail(function() {
                    console.log("ERROR al ocultar la pregunta '" + $cur_btn.data("id") + "'");
                }).always(function () {
                    is_on_execution = false;
                    init();
                });
            });
        }
    }).always(function () {
        next_init();
    });

}

if ($wrap.length > 0) {
    init();
}
